module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEAAAABACAYAAACqaXHeAAABWklEQVR42u3aTYrCMBiA4d7AjSsZvIAH8DIeZnaDB3DlcTzArEdnO8wZguCnKRVU+pPE5OtP3sIHJS2079PSVQsRKXKeAgAAAAAAAAAAAAAAADIH+NwfJJetan0GKNZfkgOCbbSttQBTR7jHtwJMFeExvhNgagiv8U4AU0Goi3cGGDtCU7wXwFgR2uK9AcaG0BUfBDAWBJf4YIChI7jGvwUwVASf+LcBhobgGx8FYCgIIfHRAPpGCI2PChCCcDG/cv7biDl9lGP37ZpWfHQAH4SLOd6il2J+Zs9zW7PHNOKTALgilE/+Nb4ae0wjPhmAC0L52jcAmNNCJT4pQKoPY8z45AB1CP/bnXzPV05jz00ZrwIQiqARrwbgi6AVrwrgiqAZrw7QhaAd3wtAE0If8b0BVBdu3RTvAwAAAAAAAAAAAAAAAAAAAAB+lAQAAAAAAAAAAAAAAIC85gqh4nZtUUGUDAAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/flags/Saint-Martin.png
// module id = Rx//
// module chunks = 0 62 63